import { PREMIUM_EVENT } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Lock, Crown, Sparkles, Check } from "lucide-react";

export const openUpgrade = () => window.dispatchEvent(new CustomEvent(PREMIUM_EVENT));

export const PremiumBadge = ({ className = "", label = "Premium" }) => (
  <span className={`inline-flex items-center gap-1 rounded-full btn-premium px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${className}`}>
    <Crown className="h-3 w-3" /> {label}
  </span>
);

export const UpgradeButton = ({ children = "Passa a Premium", className = "", testid = "premium-upsell-cta-button", size = "default" }) => (
  <Button size={size} onClick={openUpgrade} className={`btn-premium border-0 rounded-full font-semibold ${className}`} data-testid={testid}>
    <Crown className="h-4 w-4 mr-2" /> {children}
  </Button>
);

export const PremiumLock = ({ title, description, children, testid, cta = "Sblocca con Premium", perks }) => (
  <div className="relative overflow-hidden rounded-2xl border" data-testid={testid}>
    <div className="blur-[6px] select-none pointer-events-none opacity-60" aria-hidden="true">{children}</div>
    <div className="absolute inset-0 grid place-items-center p-4 bg-gradient-to-b from-background/30 via-background/60 to-background/90">
      <div className="glass glow-border rounded-2xl p-5 sm:p-6 max-w-sm w-full text-center space-y-3 pop-in shadow-xl">
        <div className="h-12 w-12 rounded-2xl bg-brand grid place-items-center mx-auto pulse-ring"><Lock className="h-6 w-6 text-white" /></div>
        <h4 className="font-heading text-lg font-semibold leading-snug">{title}</h4>
        {description && <p className="text-sm text-muted-foreground">{description}</p>}
        {perks && (
          <ul className="text-xs text-left space-y-1 inline-block">
            {perks.map((p) => <li key={p} className="flex items-center gap-1.5"><Check className="h-3.5 w-3.5 text-primary" /> {p}</li>)}
          </ul>
        )}
        <UpgradeButton testid={`${testid}-cta`}>{cta}</UpgradeButton>
      </div>
    </div>
  </div>
);

export const UpsellBanner = ({ title, text, testid = "upsell-banner", cta = "Scopri Premium" }) => (
  <div className="relative overflow-hidden rounded-2xl bg-brand text-white p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center gap-4 shadow-lg pop-in" data-testid={testid}>
    <div className="hero-orb h-32 w-32 bg-amber-300 -right-6 -top-10" />
    <div className="hero-orb h-24 w-24 bg-pink-400 right-24 -bottom-10" style={{ animationDelay: "2s" }} />
    <div className="relative flex items-start gap-3 flex-1">
      <div className="h-10 w-10 rounded-xl bg-white/20 grid place-items-center shrink-0"><Sparkles className="h-5 w-5" /></div>
      <div>
        <div className="font-heading text-lg font-semibold leading-tight">{title}</div>
        <p className="text-sm text-white/85 mt-0.5">{text}</p>
      </div>
    </div>
    <Button onClick={openUpgrade} className="relative bg-white text-[#7A2FF2] hover:bg-white/90 rounded-full font-semibold shrink-0" data-testid={`${testid}-cta`}>
      <Crown className="h-4 w-4 mr-2" /> {cta}
    </Button>
  </div>
);
